import * as React from 'react';
import { Translation } from 'react-i18next';
import { getI18nInstance } from '../i18next/translations-provider';
export const withTranslation = (component) => {
    return (props) => {
        const i18n = getI18nInstance();
        if (i18n) {
            return React.createElement(component, {
                ...props,
                t: (k, o) => i18n.t(k, o),
            });
        }
        return (React.createElement(Translation, null, (t) => React.createElement(component, { ...props, t })));
    };
};
//# sourceMappingURL=with-translation.js.map